/**
 * 画布页面header
 */
import React, { useState, useContext, memo } from 'react';
import { history } from 'ice';
import { appHistory } from '@ice/stark-app';
import { Select, Button } from '@alifd/next';
import LzTag from '@/components/common/LzTag'
import LzMsg from '@/components/common/LzMsg';
import LzDialog from '@/components/common/LzDialog';
import styles from './index.module.scss';
import logoPic from '@/assets/images/CanvasImages/canvas-editor-logo.png';
import un_commit_img from '@/assets/images/CanvasImages/un-commit-img.png';
import preview_img from '@/assets/images/CanvasImages/preview.png';
import ready_img from '@/assets/images/CanvasImages/ready.png';
import running_img from '@/assets/images/CanvasImages/running.png';
import pause_img from '@/assets/images/CanvasImages/pause.png';
import stop_img from '@/assets/images/CanvasImages/stop.png';
import done_img from '@/assets/images/CanvasImages/done.png';
import { ActivityContext, PageType, SaveTarget, SaveType } from '../../index';
import { CanvasService } from '@/service';
import ConfirmDialog from '@/components/canvas/ConfirmDialog';

// 运行状态枚举
enum RunState {
  uncommited = 0, // 未提交
  preview = 1, // 预执行
  ready = 2, // 待执行
  running = 3, // 执行中
  pause = 4, // 已暂停
  stop = 5, // 已停止
  done = 9, //已完成
}

// 编辑页面可执行的操作列表
const editorOperationList = [
  {
    label: '提交',
    value: 1,
  },
  {
    label: '预执行',
    value: 2,
  }
];

const statusList = [ //活动状态列表
  {
    name: '未提交',
    key: 0,
    progressSpeed: `un-commit-speed`,
    color: '#E6A23C',
    bgColor: '#FCF6EC',
    img: un_commit_img
  },
  {
    name: '预执行',
    key: 1,
    progressSpeed: `preview-speed`,
    color: '#96E0FF',
    bgColor: '#F0FBFF',
    img: preview_img
  },
  {
    name: '待执行',
    key: 2,
    progressSpeed: `ready-speed`,
    color: '#FCD190',
    bgColor: '#FCF6EC',
    img: ready_img
  },
  {
    name: '执行中',
    key: 3,
    progressSpeed: `running-speed`,
    color: '#9FCEFF',
    bgColor: '#ECF5FF',
    img: running_img
  },
  {
    name: '已暂停',
    key: 4,
    progressSpeed: `pause-speed`,
    color: '#C7C9CC',
    bgColor: '#F4F4F5',
    img: pause_img
  },
  {
    name: '已停止',
    key: 5,
    progressSpeed: `stop-speed`,
    color: '#FAB5B5',
    bgColor: '#FEF0F0',
    img: stop_img
  },
  {
    name: '已完成',
    key: 9,
    progressSpeed: `success-speed`,
    color: '#B3E09C',
    bgColor: '#F0F9EB',
    img: done_img
  },
]

const RunStateTag = ({status}) => {
  // switch (status) {
  //   case RunState.uncommited:
  //     return <LzTag.Warning shadow>未提交</LzTag.Warning>;
  //   case RunState.preview:
  //     return <LzTag.Success shadow>预执行</LzTag.Success>;
  //   case RunState.ready:
  //     return <LzTag.Success shadow>待执行</LzTag.Success>;
  //   case RunState.running:
  //     return <LzTag.Success shadow>执行中</LzTag.Success>;
  //   case RunState.pause:
  //     return <LzTag.Error shadow>已暂停</LzTag.Error>;
  //   case RunState.stop:
  //     return <LzTag.Error shadow>已停止</LzTag.Error>;
  //   case RunState.done:
  //     return <LzTag.Success shadow>已完成</LzTag.Success>;
  //   default:
  //     return <span/>;
  // }

  const val = statusList.filter((obj) => obj.key === status)[0];
//   return <div className={styles['activity-status']}>
//     <img src={val?.img} alt="" />
//   </div>

  return <div className={styles['activity-status']} style={{backgroundColor: val?.bgColor, border: `1px solid ${val?.color}`}}>
    <img src={val?.img} alt="" />
    <div style={{color: val?.color, marginLeft: 3}}>{val?.name}</div>
  </div>
}

const Header = ({save = (target, type, callbackFunction) => {}, initGraph = () => {}}) => {

  const { pageInfo, activityInfo, runInfo, changeRunInfo, isSave, checkExpiredNode, checkAllNodes } = useContext(ActivityContext);

  const [editorOperation, setEditorOperation] = useState(1);

  const [selectBtnShow, setBtnShow] = useState(false); //下拉操作框提交或预执行按钮的弹层是否展示

  const [winShow, setWinShow] = useState(false); //点击退出的二次确认弹窗

  /**
   * 预执行页面操作
   */
  // 停止预执行
  const stopPreActivity = () => {
    CanvasService.stopPreActivity({
      campaignId: pageInfo.campaignId
    }).then(res => {

      save(SaveTarget.process, SaveType.stopPreview);
    }).catch(e => {
      console.log(e)
    })
  }

  /**
   * 详情页面操作
   */
   /**
   * 继续
   */
  const continueActivity = async () => {
    try {
      if (activityInfo.executionPlan.type === 1) {
        await checkExpiredNode();
      }
      CanvasService.continueActivity({
        campaignId: pageInfo.campaignId
      }).then(res => {
        initGraph();
        LzMsg.success('继续执行成功');
      }).catch(e => {
        console.log(e)
      })
    } catch (e) {
      LzMsg.error(e.message);
    }
  }
  /**
   * 暂停
   */
  const pauseActivity = () => {
    CanvasService.pauseActivity({
      campaignId: pageInfo.campaignId
    }).then(res => {
      initGraph();
      LzMsg.success('暂停成功');
    }).catch(e => {
      console.log(e)
    })
  }
  /**
   * 停止
   */
  const stopActivity = () => {
    CanvasService.stopActivity({
      campaignId: pageInfo.campaignId
    }).then(res => {
      initGraph();
      LzMsg.success('停止活动成功');
    }).catch(e => {
      console.log(e)
    })
  }

  /**
   * 编辑页面切换下拉选框操作类型
   */
  const changeSaveType = (val) => {
    setEditorOperation(val);
    setBtnShow(false);
    if(val === '1') {
      save(SaveTarget.process, SaveType.submit);
    } else {
      save(SaveTarget.process, SaveType.pre);
    }
  }

  /**
   * 立即执行直接点击
   */
  const handelSubmit = () => {
    setBtnShow(false);
    save(SaveTarget.process, SaveType.submit);
  }

  /**
   * 预执行直接点击
   */
  const handlePre = () => {
    setBtnShow(false);
    save(SaveTarget.process, SaveType.pre);
  }

  /**
   * 执行中活动查看不同执行次数的活动详情，用以返回样式
   */
  const searchActivityLoopDetail = (item, index) => {
      // 判断当次活动是不是有执行失败的节点，样式需要展示警示叹号
      let tips = false;
      item.actInsts.forEach(it => {
        if (item.errorMsg[`${it.resourceId}`]) {
          tips = true;
        }
      })
      return {
        name: index + 1,
        currentProgress: item.progress,
        tips: tips
      }
  }

  /**
   * 确认退出
   */
  const confirmCancel = async () => {
    history.push(`/canvas/activities`, { source: 'editor' })
  }

  return (
    <div className={styles['page-header']}>
      <img alt="" src={logoPic} />
      <span className={styles['activity-name']} style={{fontSize: '16px'}}>自定义活动设计</span>
      <span className={styles['activity-name']}>活动名称：{activityInfo.campaignName}</span>
      <RunStateTag status={activityInfo.campaignState}/>
      {
        pageInfo.type === PageType.detail && runInfo.currentCycleIndex >= 0 &&  // 添加了runInfo.currentCycleIndex >= 0是因为待执行状态并没有多次循环状态可查询，直接不展示下拉框
        <Select className={`canvas-activity-progress-select ${styles['cycle-selector']}`}
          value={runInfo.currentCycleIndex}
          onChange={(currentCycleIndex) => {changeRunInfo({currentCycleIndex})}}>
            {
              runInfo.cycles.map((cycle, index) => {
                const cycleContent = searchActivityLoopDetail(cycle, index);
                return (
                  <Select.Option value={index} key={index} className='current-canvas-option'>
                    <div key={index} className='current-canvas-display-flex current-canvas-activity-list'>
                      <div>{cycleContent.name}</div>
                      <div key={index} className='current-canvas-display-flex progress-speed'>
                        <div className={`canvas-activity-progress-gray-bar`}>
                          <div className={statusList.filter((obj) => obj.key === cycle.status)[0]?.progressSpeed} style={{width: cycle.progress + '%', height: '4px', background: cycleContent.tips ? '#FF9900' : ''}}></div>
                        </div>
                        {/* <div style={{minWidth: '30px'}}>
                          {
                            cycle.status === 9 ? <span className="iconfont icon-icon4-24" style={{color: '#00bb66'}}/> : cycleContent.tips ? <span className="iconfont icon-icon4-36" style={{color: '#FF9900'}}/> : <span>{cycle.progress}%</span>
                          }
                        </div> */}
                      </div>
                    </div>
                  </Select.Option>
                )
              })
            }
        </Select>
      }
      <div className={`${styles['offset']}`}/>
      {
        pageInfo.type === PageType.editor && <>
          {/* <SplitButton label="立即提交" visible={selectBtnShow} onItemClick={key => changeSaveType(key)} onVisibleChange={() => setBtnShow(!selectBtnShow)}>
            <SplitButton.Item key={1}>立即提交</SplitButton.Item>
            <SplitButton.Item key={2}>预执行</SplitButton.Item>
          </SplitButton> */}
          <Button type="secondary" className={styles['main-button']} onClick={handelSubmit}>立即提交</Button>
          <Button type="secondary" className={styles['main-button']} onClick={handlePre}>预执行</Button>
        </>
      }
      {
        pageInfo.type === PageType.preview && <Button type="secondary" className={styles['main-button']} onClick={stopPreActivity} style={{padding: 0}}>停止预执行</Button>
      }
      {/* 2022.11.11 由于大促期间，客服对功能的不理解，导致对接客户时，没有解释清楚，赔付了1w费用，所以暂时禁用暂停功能 */}
      {/* {
        (pageInfo.type === PageType.detail && runInfo.currentCycleState.status === 3) && <Button type="secondary" className={styles['main-button']} onClick={pauseActivity}>暂停</Button>
      }
      {
        (pageInfo.type === PageType.detail && runInfo.currentCycleState.status === 4) && <Button type="secondary" className={styles['main-button']} onClick={continueActivity}>继续执行</Button>
      }*/}
      {
        pageInfo.type === PageType.detail && (runInfo.currentCycleState.status === 3 || runInfo.currentCycleState.status === 4) && <Button type="secondary" className={styles['main-button']} onClick={stopActivity}>停止活动</Button>
      }
      <Button className={styles['go-out-button']} onClick={() => { pageInfo.type === 'editor' ? setWinShow(true) : history.push(`/canvas/activities`, { source: 'editor' }) }}>退出</Button>

      {/* 退出二次确认弹窗 */}
      {winShow &&
        <ConfirmDialog
          type="WARN"
          title="提示"
          promptInfo='未保存的节点退出后会丢失，请知悉！'
          flag={winShow}
          confirmHandel={confirmCancel}
          cancelHandel={() => setWinShow(false)}
          saveHandel={() => save(SaveTarget.process, SaveType.save, confirmCancel)}
        />
      }

    </div>
  )
};
export default memo(Header);
